import i18n from '@/plugins/i18n';

const detailsGraphs = () => ({
  metricChart: [
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('vm.windows.cpuUsagePercentage'),
      height: '30%',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_cpu_total_percentage',
      queryMetricType: 'readMetricsValue',
      chartType: 'ChartMetric',
      unit: i18n.global.t('key'),
    },
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('memory-ram-usage-mb'),
      height: '30%',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_memory_used',
      queryMetricType: 'readMetricsValue',
      chartType: 'ChartMetric',
      unit: 'MB',
      aggregation: '/',
      aggregationNum: '1048576',
    },
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('memory-swap-usage'),
      height: '30%',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_memory_swap_percentage',
      queryMetricType: 'readMetricsValue',
      chartType: 'ChartMetric',
      unit: i18n.global.t('key'),
    },
  ],
  areaCharts: [
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('cpu-load'),
      header: {
        title: i18n.global.t('cpu-load-average'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      chartColor: ['#ffbe0b', '#ff046e', '#8338ec'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_cpu_load1,meter_vm_cpu_load5,meter_vm_cpu_load15',
      queryMetricType: 'readMetricsValues',
      aggregation: '/',
      aggregationNum: '100',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'ms',
      metricLabels: '',
      isSynchronized: false,
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: '',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('memory-swap-mb'),
      header: {
        title: i18n.global.t('memory-swap-mb'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      chartColor: ['#e63a46', '#d0efc5'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_memory_swap_free,meter_vm_memory_swap_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      isSynchronized: false,
      aggregation: '/',
      aggregationNum: '1048576',
      unit: 'MB',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('disk-r-w-kb-s'),
      header: {
        title: i18n.global.t('disk-r-w-kb-s'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      chartColor: ['#d71359', '#ffbc41'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_disk_read,meter_vm_disk_written',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      isSynchronized: false,
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1024',
      unit: 'KB/s - OTEL, ops - Zabbix',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'KB/s',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('network-status'),
      header: {
        title: i18n.global.t('network-status'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      chartColor: ['#5CA8FF', '#0DCEBF', '#FFCC55', '#A0A7E6', '#EA7699'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_vm_tcp_curr_estab,meter_vm_tcp_tw,meter_vm_tcp_alloc,meter_vm_sockets_used,meter_vm_udp_inuse',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      isSynchronized: false,
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: '',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
  ],
  lineCharts: [
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('filefd-allocated'),
      header: {
        title: i18n.global.t('filefd-allocated'),
        titleIcon: '',
        content: [],
        toolbar: false,
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_filefd_allocated',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isSynchronized: false,
      unit: 'KB/s',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'KB/s',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
  ],
  forecastDisabledAreaChart: [
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('cpu-average-used'),

      header: {
        title: i18n.global.t('cpu-average-used'),
        subIconTitle: 'starFilled',
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'meter_vm_cpu_average_used',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: 'ms',
      metricLabels: '',
      isSynchronized: false,
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('memory-ram-mb'),
      header: {
        title: i18n.global.t('memory-ram-mb'),
        subIconTitle: 'starFilled',
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#1be7ff', '#6eeb83', '#e4fe1a'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_vm_memory_total,meter_vm_memory_available,meter_vm_memory_used',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      aggregation: '/',
      aggregationNum: '1048576',
      isSynchronized: false,
      unit: 'MB',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('file-system-mount-point-usage'),
      header: {
        title: i18n.global.t('file-system-mount-point-usage'),
        subIconTitle: 'starFilled',
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'meter_vm_filesystem_percentage_used',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      isSynchronized: false,
      aggregation: '+',
      aggregationNum: '0',
      unit: i18n.global.t('key'),
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('vm.windows.networkBandwidth'),
      header: {
        title: i18n.global.t('vm.windows.networkBandwidth'),
        subIconTitle: 'starFilled',
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#564592', '#ecfa7f'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_network_receive,meter_vm_network_transmit',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      isSynchronized: false,
      aggregation: '/',
      aggregationNum: '1024',
      unit: 'KB/s',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'KB/s',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
  ],
});
export default detailsGraphs;
